export enum PurchaseOrderTerms {
  DUE_ON_RECEIPT = 'Due On Receipt',
  NET15 = 'Net 15',
  NET30 = 'Net 30',
  NET45 = 'Net 45'
}
